export default {
    'Version': 'Workflow Version',
    'FinishTime': 'Finish Time: {time}',
    'CancelTime': 'Cancel Time: {time}',
    'CurNode': 'Current Activity',
    'CurHandler': 'Current Approvers',
    'UsedTime': 'Used Time {time}',
    'WorkflowTrack': 'Workflow track',
    'Edit': 'Edit',
    'AdjustNode': 'Activities Adjustment',
    'ProcessOperationAndMaintenance': 'Process Operation And Maintenance',
    'Nullify': 'Cancel',
    'Delete': 'Delete',
    'Logs': 'Operate Log',
    'Finish': 'Finish',
    'EditOwner': 'Modify owner',
    'NullifyTips': 'The workflow will be stuck after cancel,are you sure to cancel?',
    'NullifyTips1': 'Sure to void?',
    'NullifyTips2': 'The process will stop circulating after it is invalidated',
    'DeleteTips1': 'All workflow data will be delete after workflow instance be deleted, ',
    'DeleteTips2': 'and it can not restore after delete',
    'DeleteTips3': 'Are you sure to delete?',
    'Total': 'Total {num}',
    'WorkHandover': 'Work handover',
    'organization': 'Organization',
    'organizationTips1': 'Incumbents and ex-employees conduct job handovers through personnel and department search',
    'organizationRole': 'Organization Role',
    'organizationTips2': 'Job handover through role search',
    'SelectAction': 'Select Process Action',
    'FinishWorkflow': 'End the Workflow ahead of schedule',
    'FinishWorkflowTips': 'Are you sure to end the workflow right now？',
    'WorkflowChart': 'WorkFlow diagram',
    'SmallScreen': 'Exit fullScreen',
    'ApprovalLog': 'Approve Log',
    'Describe': 'Describe',
    'Back': 'Back',
    'OperationLogs': 'User Operation Log',
    'NoOperationLogs': 'No User Operation Log',
    'View': 'Check',
    'DetailInfo': 'Details',
    'Number': 'NO.',
    'OperationType': 'Operation Type',
    'OperationTime': 'Operation Time',
    'User': 'User',
    'Operations': 'Operation with',
    'Platform': 'Platform',
    'Detail': 'Details',
    'Assist': ' assist]',
    'AddWorkitem': ' add-approver]',
    'Circulate': ' circulate]',
    'Forward': ' transfer]',
    'ActivityName': 'Activity Name',
    'ReceiveTime': 'Received Time',
    'FinishTimes': 'Finish Time',
    'CostTime': 'Used Time',
    'Originator': 'Paticipants',
    'ApprovalAction': 'Action',
    'consignor': 'Consignor',
    'FinishNode': 'Ended Activity',
    'ProcessNode': 'Processing Activity',
    'ExceptionNode': 'Abnormal Activity',
    'UnstartNode': 'Unstarted Activity',
    'WorkflowName': 'Workflow Name',
    'Status': 'Status',
    'StartTime': 'Start Time',
    'FinishedTime': 'End Time',
    'BaseInfo': 'Basic Information',
    'NoFinishOriginator': 'Unfinished Approver',
    'ViewDetails': 'Details',
    'ChooseAdjustType': 'Choose a type',
    'AdjustOriginator': 'Current Approver Adjustment',
    'CancelAllTask': 'Cancel all task of the activity',
    'ActivateNodes': 'Activate another activity',
    'AdjustNodeTips': 'Tips:Workflow will keep stuck,and administrator need to activate another activity.',
    'notNodeTips': 'No nodes currently available',
    'ChooseNode': 'Adjust Activity',
    'ChooseHandler': 'Choose the approver',
    'ClickChoose': 'Click and choose',
    'Null': 'Empty',
    'Nothing': 'Nothing',
    'Cancel': 'Cancel',
    'OK': 'OK',
    'Ok&Del': 'Ok & Delete',
    'Predictor': 'Predict approver',
    'NoDetail': 'There is no details',
    'trust': '【{name} entrust】',
    'trust2': ' entrust',
    'Person': ' person ',
    'Give': ' give ',
    'giveYou': ' give you',
    'Of': ' of ',
    'NewWorkflow': 'New Workflow',
    'NewWorkflowTips': 'Quickly create a new process that belongs to you',
    'ParamsSetting': 'Parameter settings',
    'HistoryVersion': 'History Version',
    'ParamsSetting1': 'PC initiated',
    'ParamsSetting2': 'Mobile initiated',
    'ParamsSetting3': 'Initiate permission setting',
    'ParamsSetting4': 'After the app is disabled, the permission setting for initiating is invalid, and no one can initiate the process',
    'ParamsSetting5': 'Everyone can initiate',
    'ParamsSetting6': 'User scope',
    'ParamsSetting7': 'Add permission',
    'ParamsSetting8': 'Update successful',
    'ParamsSetting9': 'Are you sure you want to remove user rights? ',
    'ParamsSetting10': 'Delete process permission successfully',
    'ParamsSetting11': 'You do not have the management scope of this department/person and cannot delete it',
    'ParamsSetting12': 'Deletion failed, permission has been removed',
    'ParamsSetting13': 'Please set the permission content',
    'ParamsSetting14': 'Creation process permission succeeded',
    'ParamsSetting15': '{num} process permission creation failed',
    'HistoryVersion1': 'Process code',
    'HistoryVersion2': 'Because the process simulation operation will occupy the version number, the version number of the official operation will be discontinuous',
    'HistoryVersion3': 'View',
    'SetPrivilege1': 'Process operation and maintenance privileged person',
    'SetPrivilege2': 'New process operation and maintenance privileged person',
    'SetPrivilege3': 'Edit process operation and maintenance privileged person',
    'SetPrivilege4': 'User scope',
    'SetPrivilege5': 'Process operation and maintenance scope',
    'SetPrivilege6': 'Process operation',
    'SetPrivilege7': 'Void process',
    'SetPrivilege8': 'End process',
    'SetPrivilege9': 'Delete process',
    'SetPrivilege10': 'Node operation',
    'SetPrivilege11': 'Adjust the current handler',
    'SetPrivilege12': 'Cancel all tasks of the current node',
    'SetPrivilege13': 'Activate other nodes',
    'SetPrivilege14': 'Process data manipulation',
    'SetPrivilege15': 'Modify owner',
    'SetPrivilege16': 'User scope cannot be empty! ',
    'SetPrivilege17': 'The scope of process operation and maintenance cannot be empty! ',
    'SetPrivilege18': 'Please confirm whether to delete it or not. After deletion, it will affect the process in progress and the new process! ',
    'SetPrivilege19': 'Added successfully',
    'SetPrivilege20': 'Modified successfully',
    'SetPrivilege21': 'Cancel the current node task',
    'SetPrivilege22': 'Activate node',
    'WorkflowState': {
        'Draft': 'Draft',
        'Processing': 'Processing',
        'Completed': 'Completed',
        'Canceled': 'Canceled',
        'Exception': 'Exception',
    },
    'WorkflowActionStatus': {
        'Submit': 'Submit',
        'Submits': 'Submit',
        'Cancel': 'Cancel',
        'Agree': 'Approve',
        'DisAgree': 'Disagree',
        'AdjustParticipant': 'Add-approver',
        'Assist': 'Assist',
        'Forward': 'Transfer',
        'Reject': 'Reject',
        'FinishInstance': 'End-workflow',
        'UnRead': 'Unread',
        'Read': 'Read',
        'Circularize': 'Circularize',
        'Empty': '',
        'Revoke': 'Revoke',
        'BeCanceled': 'Be Canceled',
        'AutoCanceled': 'Auto Cancel',
        'ActivateActivity': 'Activate Other Nodes',
        'ADJUST_PARTICIPANT': 'Adjust Current Processor',
        'CANCELED_ACTIVITY_WORKITEM': 'Cancel All Tasks Of The Node',
        'MODIFY_OWNER': 'Modify Owner',
    },
    'WorkItemStatus': {
        'NotStarted': 'Not Started',
        'Processing': 'Processing',
        'Completed': 'Completed',
        'Canceled': 'Canceled',
        'Draft': 'Draft',
        'BeCanceled': 'Be Canceled',
    },
    'SubWorkItemStatus': {
        'NotStarted': 'Not Started',
        'Processing': 'Processing',
        'Completed': 'Completed',
        'Canceled': 'Canceled',
        'Exception': 'Exception',
        'BeCanceled': 'Be Canceled',
    },
    'workflow': Object.assign({}, require('@cloudpivot/common/locales/machine/en-US.json'))
};
